export const FAUCET_URL =
  "https://dlsb7da2r7.execute-api.eu-west-1.amazonaws.com/staging/address";
